import { render, staticRenderFns } from "./NotificationIcon.vue?vue&type=template&id=b765a4dc&scoped=true"
import script from "./NotificationIcon.vue?vue&type=script&lang=js"
export * from "./NotificationIcon.vue?vue&type=script&lang=js"
import style0 from "./NotificationIcon.vue?vue&type=style&index=0&id=b765a4dc&prod&lang=scss&scoped=true"
import style1 from "./NotificationIcon.vue?vue&type=style&index=1&id=b765a4dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b765a4dc",
  null
  
)

export default component.exports